import React, { useMemo } from "react";

import { ColumnsType } from "antd/es/table";
import Tag from "antd/es/tag";
import { useIntl } from "react-intl";

import { Company, Deal, EntityType, Person } from "@mapmycustomers/shared/types/entity";
import { OutOfCadenceEntity } from "@mapmycustomers/shared/types/entity/activities/OutOfCadenceEntity";
import { Avatar } from "@mapmycustomers/ui";

import CompanyNameWithAddress from "@app/component/company/CompanyNameWithAddress";
import DealName from "@app/component/deal/DealName";
import PersonNameWithAddress from "@app/component/person/PersonNameWithAddress";
import { formatRawDate } from "@app/util/formatters";
import { getRecordSourceTypeDisplayName } from "@app/util/ui";

import { messages } from "./messages";

const useSourceListModalColumns = (
  onCompanyPreview: (companyId: Company["id"]) => void,
  onPersonPreview: (personId: Person["id"]) => void
): ColumnsType<OutOfCadenceEntity> => {
  const intl = useIntl();
  return useMemo(
    () => [
      {
        dataIndex: "name",
        render: (_any, entity) => {
          if (entity.entity === EntityType.COMPANY) {
            return <CompanyNameWithAddress company={entity as Company} />;
          } else if (entity.entity === EntityType.PERSON) {
            return <PersonNameWithAddress person={entity as Person} />;
          } else if (entity.entity === EntityType.DEAL) {
            return (
              <DealName
                deal={entity as Deal}
                onCompanyClick={onCompanyPreview}
                onPersonClick={onPersonPreview}
              />
            );
          }
        },
        title: intl.formatMessage(messages.name),
      },
      {
        dataIndex: "createdAt",
        render: (_any, entity) => {
          return <Tag>{formatRawDate(entity.createdAt, "PPP")}</Tag>;
        },
        title: intl.formatMessage(messages.createdAt),
      },
      {
        dataIndex: "user",
        render: (user) => <Avatar user={user} />,
        title: intl.formatMessage(messages.user),
      },
      {
        dataIndex: "sourceCreated",
        render: (name, entity) => {
          return (
            <div>
              {entity.sourceCreated?.source &&
                getRecordSourceTypeDisplayName(intl, entity.sourceCreated.source)}
            </div>
          );
        },
        title: intl.formatMessage(messages.sourceCreated),
      },
    ],
    [intl, onCompanyPreview, onPersonPreview]
  );
};

export default useSourceListModalColumns;
